/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Colleague_SearchInputs */



/**
* | output |
* | --- |
* | "Search for a colleague" |
*
* @param {Meetings_Colleague_SearchInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_colleague_search = /** @type {((inputs?: Meetings_Colleague_SearchInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Colleague_SearchInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Zoek een collega")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rechercher un collègue")
	return /** @type {LocalizedString} */ ("Search for a colleague")
});